import React, { useEffect } from "react";
import PropTypes from "prop-types";
/* Components */
import BlurredNumber from "../../CommonForBoth/Blurred/BlurredNumber";
import { Container, Row, Col } from "react-bootstrap";
import Badges from "../../CommonForBoth/Badges";
import { Card } from "semantic-ui-react";
/* Store */
import { selectEthCallMultiple } from "@ensuro/ethereum-store";
import { selectAPICallMultiple } from "@ensuro/api-calls-store";
/* i18n */
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
/* Helpers */
import { addRemoveSub } from "@/helpers/store_helper";
import { calcOnLoad } from "@/helpers/ensuro_helper";
import { apy, apy360, images } from "@/config";
import "./../style.scss";

const makeEthCalls = function (etkAddress) {
  return [
    { address: etkAddress, abi: "EToken", method: "totalSupply", args: [] },
    { address: etkAddress, abi: "EToken", method: "scr", args: [] },
    { address: etkAddress, abi: "EToken", method: "minUtilizationRate", args: [] },
  ];
};

const makeAPICalls = (etkAddress) => {
  return [
    { apiName: "apy", args: [etkAddress, apy.range] },
    { apiName: "apy", args: [etkAddress, apy360.range] },
  ];
};

const ETokenRowDesktop = ({ t, eToken, idx, totalSupply, scr, minUtilizationRate, apy30, apy360, poolBadges }) => {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  let tags = eToken.custom_data?.tags || [];

  const isOversold = calcOnLoad((ts, scr, minUR) => scr / ts < minUR, totalSupply, scr, minUtilizationRate);
  if (isOversold.value === true) {
    tags = [...tags, "oversold"];
  }

  const handleCardClick = (address) => {
    navigate(`/eTokens/${address}`);
  };

  useEffect(() => {
    return addRemoveSub(
      dispatch,
      `etkDesktop-${eToken.address}`,
      makeAPICalls(eToken.address),
      makeEthCalls(eToken.address)
    );
  }, [dispatch, eToken.address]);

  return (
    <Container className="desktop no-margin">
      <Card className="card-row card-hover primary-colored" onClick={() => handleCardClick(eToken.address)} key={idx}>
        <Container className="no-margin">
          <Row>
            <Col md={3} className="font-size-16 margin-auto">
              <span className="logo-sm with-20-padding">
                <img src={eToken.logo || images.defaultEtkLogo} alt="" height="35" />
              </span>{" "}
              {eToken.name}
            </Col>
            <Col md={3} className="font-size-16 margin-auto text-align-center">
              <Badges tags={tags} badgesData={poolBadges} />
            </Col>
            <Col md={2} className="margin-auto">
              <Card className="card-inside primary-colored">
                <BlurredNumber number={totalSupply} options={{ maximumFractionDigits: 2, notation: "compact" }} />
              </Card>
            </Col>
            <Col md={2} className="margin-auto">
              <Card className="card-inside primary-colored">
                <BlurredNumber
                  number={calcOnLoad((a, b) => a / b, scr, totalSupply)}
                  options={{ maximumFractionDigits: 2, notation: "standard" }}
                  percentage={true}
                  suffix={"%"}
                />
              </Card>
            </Col>
            <Col md={1} className="margin-auto">
              <Card className="card-inside primary-colored">
                <BlurredNumber
                  number={apy30}
                  suffix={"%"}
                  percentage={true}
                  options={{ maximumFractionDigits: 0, notation: "standard" }}
                />
              </Card>
            </Col>
            <Col md={1} className="margin-auto">
              <Card className="card-inside primary-colored">
                <BlurredNumber
                  number={apy360}
                  suffix={"%"}
                  percentage={true}
                  options={{ maximumFractionDigits: 0, notation: "standard" }}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </Card>
    </Container>
  );
};

ETokenRowDesktop.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = (state, ownProps) => {
  const etkAddress = ownProps.eToken.address;
  const [totalSupply, scr, minUtilizationRate] = selectEthCallMultiple(state.EthereumReducer, makeEthCalls(etkAddress));
  const [apy30, apy360] = selectAPICallMultiple(state.APIReducer, makeAPICalls(etkAddress));
  return { totalSupply, scr, apy30, apy360, minUtilizationRate };
};

export default connect(mapStateToProps)(withTranslation()(ETokenRowDesktop));
